// extracted by mini-css-extract-plugin
export default {"breakText":"style-module--breakText--qTrdd","title":"style-module--title--Ao+W0"};